<template>
	<div class="case-container" v-loading="loading">
		<div class="box6 mainCont">
			<div class="b_list">
				<div class="l_left" v-for="(item,index) in list" :key="index" @click="goNews(item)">
					<img :src="item.img" alt="1" class="img">
					<div class="in_title"><h4>{{item.name}}</h4></div>
				</div>
			</div>
		</div>
		
		<el-empty v-if="!loading&&list.length==0" description="暂无服务项目"></el-empty>
		
		<div class="pageBox">
			<el-pagination background layout="prev, pager, next" :page-size="pageSize" :hide-on-single-page="true" :total="total" @current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>
<script >
	
import {getXwzxList} from '@/api/api'
export default {
	name: 'home2',
	data() {
		return {
			
			list:[],
			pageIndex:1,
			pageSize:10,
			total:0,
			loading:true,
		};
	},
	mounted() {
		this.getProductList();
	},
	methods: {
		
		getProductList(){
			this.loading = true;
			let pageIndex = this.pageIndex;
			getXwzxList({pageIndex,pageSize:this.pageSize,}).then(res => {
				let list = res.data;
				this.total = res.total;
				this.list = list;
				this.loading = false;
			})
		},
		// 分页
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getProductList();
		},
		goNews(item){
			this.$router.push({
			path: '/news/detail',
				query: {
					id: item.id
				}
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.case-container{background-color: #F5F8F9;padding-top:24px;
	.box6{
		.b_list{display: flex;align-items: center;justify-content: flex-start;flex-wrap: wrap;
			.l_left{width: 24%;height: 358px;position: relative;overflow: hidden;border-radius: 10px;margin-bottom: 20px;
				margin-right: 1.33%;cursor: pointer;
				&:nth-child(4n+4){margin-right: 0;}
				.img{width: 100%;height: 100%;border-radius: 10px;}
				.in_title{position: absolute;left: 0;right: 0;bottom: 0;height: 112px;background: linear-gradient( 180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,.5) 100%);padding: 16px;
					display: flex;flex-direction: row;align-items: flex-end;
					h4{color: #FFFFFF;font-size: 20px;transition: all .3s;}
				}
				&:hover{
					h4{color: #2F78FF;}
				}
			}
		}
	}
	

	.pageBox{display: flex;align-items: center;justify-content: space-around;margin-bottom: 30px;}
}
</style>


// WEBPACK FOOTER //
// src/views/news/index.vue